// achievementsData.js
// Nilai dihitung langsung dari sumber data masing-masing section
// sehingga cukup tambah/hapus entry di file data tersebut, dan angka di sini otomatis ikut.

import { experiencesData }    from './experiencesData';
import { rawCertificatesData } from './certificatesData';
import { rawPortfolioData }    from './portfolioData';
import { rawSkillsData }       from './skillsData';

export const achievementsData = {
  projects:      rawPortfolioData.length,
  experience:    experiencesData.length,
  technologies:  rawSkillsData.length,
  certificates:  rawCertificatesData.length,
};
